import { render } from "./ListeRegimePage.vue?vue&type=template&id=2e3d42c0&ts=true"
import script from "./ListeRegimePage.vue?vue&type=script&lang=ts"
export * from "./ListeRegimePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__